import httpRequest from "@/services/httpRequest"
import quranData from '@/assets/json/quran_metadata.json'
import { create } from "qrcode"
import id from "dayjs/locale/id"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    classRooms: [],
    classRoom: null,
    studentClassRooms: [],
    students: [],
    student: null,
    studentStats: {},
    tahfidzStudentClassRooms: [],
    search: '',
    searchMember: '',
    searchAddMember: '',
    page: 1,
    pageMember: 1,
    pageAddMember: 1,
    rows: 20,
    filter: '',
    tahfidzs: [],
    tahfidz: null,
    surahs: [],
    classroomEvaluation: [],
    studentClassroomEvaluation: [],
    studentEvaluation: [],
  },
  mutations: {
    SET_STUDENT_CLASSROOMS(state, data) {
      state.studentClassRooms = data
    },
    SET_STUDENT_FIRST(state, data) {
      state.students = data
    },
    SET_STUDENT(state, data) {
      data.forEach((student) => {
        state.students.push(student)
      })
    },
    SET_CLASSROOMS_FIRST(state, data) {
      state.classRooms = data
    },
    SET_CLASSROOMS(state, data) {
      data.forEach((classRoom) => {
        state.classRooms.push(classRoom)
      })
    },
    SET_CLASSROOM(state, data) {
      state.classRoom = data
    },
    DELETE_CLASSROOM(state, id) {
      state.classRooms = state.classRooms.filter(item => item.id !== id)
    },
    UPDATE_CLASSROOM(state, data) {
      const index = state.classRooms.findIndex(item => item.id === data.id)
      if (index !== -1) {
        state.classRooms.splice(index, 1, data)
      }

      state.classRoom = data
    },
    SET_TAHFIDZ_STUDENT_CLASSROOMS_FIRST(state, data) {
      state.tahfidzStudentClassRooms = data
    },
    SET_TAHFIDZ_STUDENT_CLASSROOMS(state, data) {
      data.forEach((student) => {
        state.tahfidzStudentClassRooms.push(student)
      })
    },
    DELETE_MEMBER(state, id) {
      //console.log(state.tahfidzStudentClassRooms)
      state.tahfidzStudentClassRooms = state.tahfidzStudentClassRooms.filter(item => item.id !== id)
    },
    SET_TAHFIDZ_STUDENT_CLASSROOM(state, data) {
      state.student = data
    },
    SET_TAHFIDZS(state, data) {
      state.tahfidzs = data
    },
    SET_TAHFIDZ(state, data) {
      state.tahfidz = data
    }
  },
  actions: {
    async getStudentClassRoom({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/classroom?rows=100&level__isnull=false`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_STUDENT_CLASSROOMS', res.data.results)
      }
    },

    async getStudent({ rootState, state, commit }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/student?query={id,name,photo,classroom}&page=${state.pageAddMember}&rows=${state.rows}&search=${state.searchAddMember}`,
          method: 'GET'
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_STUDENT_FIRST', res.data.results)
        } else {
          commit('SET_STUDENT', res.data.results)
        }
      }
    },

    async getClassRooms({ rootState, state, commit }, type) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom?rows=${state.rows}&page=${state.page}&search=${state.search}${state.filter}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (type === 'first') {
          commit('SET_CLASSROOMS_FIRST', res.data.results)
        } else {
          commit('SET_CLASSROOMS', res.data.results)
        }
        state.isLoading = false
      } else {
        state.isLoading = false
      }
    },

    async getClassRoom({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom/${id}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_CLASSROOM', res.data)
      }


      return res
    },

    async createClassRoom({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async editClassRoom({ rootState }, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async deleteClassRoom({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom/${id}`,
          method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        commit('DELETE_CLASSROOM', id)
      }

      return res
    },

    async updateClassRoom({ rootState, commit, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom/${state.classRoom.id}`,
          method: 'PUT',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('UPDATE_CLASSROOM', res.data)
      }

      return res
    },

    async getTahfidzStudentClassRooms({ rootState, commit, state }, status) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom?classroom=${state.classRoom.id}&page=${state.pageMember}&rows=${state.rows}&search=${state.searchMember}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        if (status === 'first') {
          commit('SET_TAHFIDZ_STUDENT_CLASSROOMS_FIRST', res.data.results)
        } else {
          commit('SET_TAHFIDZ_STUDENT_CLASSROOMS', res.data.results)
        }
      }
    },

    async getTahfidzStudentClassRoom({ rootState, commit, state }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom/${id}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 200) {
        commit('SET_TAHFIDZ_STUDENT_CLASSROOM', res.data)
      }

      return res
    },

    async tahfidzClassRoomDo({ rootState, commit, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom/${data.id}/do`,
          method: 'POST',
          data: data.data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async removeMember({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom/${id}`,
          method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        commit('DELETE_MEMBER', id)
      }

      return res
    },

    async addTahfidzStudentClassRoom({ rootState, commit }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async getTahfidzs({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz?real_student=${id}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        commit('SET_TAHFIDZS', res.data.results)
      }

      return res
    },

    async getSurahs({ state }) {
      let rawSurahs = [...quranData.surahs]
      rawSurahs.forEach((surah, index) => {
        state.surahs.push({
          surahNumber: index + 1,
          label: surah.surahName,
          value: surah.surahName,
          ayah: surah.totalAyah,
          // level: 'QURAN'
        })
      })
    },

    async addTahfidz({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async deleteTahfidz({ rootState, state }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz/${id}`,
          method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status === 204) {
        state.tahfidzs = state.tahfidzs.filter(item => item.id !== id)
      }

      return res
    },

    async getTahfidz({ rootState, commit }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz/${id}`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        commit('SET_TAHFIDZ', res.data)
      }

      return res
    },

    async updateTahfidz({ rootState, state }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz/${state.tahfidz.id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        // state.tahfidzs.unshift(res.data)
      }

      return res
    },

    async getStudentStats({ rootState, state }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom/${id}/stats`,
          method: 'GET',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentStats = res.data
      }
      return res
    },

    async getClassroomEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom_evaluation`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.classroomEvaluation = res.data.results
      }

      return res
    },

    async addClassroomEvaluation({ rootState }, data) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom_evaluation`,
          method: 'POST',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async editClassroomEvaluation({ rootState }, {id, data}) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom_evaluation/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async deleteClassroomEvaluation({ rootState }, id) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_classroom_evaluation/${id}`,
          method: 'DELETE',
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },

    async getStudentClassroomEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom_evaluation`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentClassroomEvaluation = res.data.results
      }

      return res
    },
    async getStudentEvaluation({ rootState, state }, param) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tilawah_classroom/get_student_evaluations_by_semester`,
          method: 'GET',
          params: param
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      if (res.status = 200) {
        state.studentEvaluation = res.data.tahfidz_evaluations
      }

      return res
    },

    async updateStudentGrade({ rootState }, { id, data }) {
      const payload = {
        options: {
          url: `${rootState.baseURL}/api/v1/tahfidz_student_classroom_evaluation/${id}`,
          method: 'PATCH',
          data: data
        },
        authorized: true
      }

      const res = await httpRequest(payload)

      return res
    },
  }
})